var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"positioning"},[(_vm.styleModel)?_c('div',{style:(_vm.styleModel.date)},[_vm._v(" "+_vm._s(_vm.renderDate(_vm.currentDate, _vm.propertiesModel, _vm.utcOffset))+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }